var n={Trunk:"Trunk",Commercial:"Commercial",OwnConsumption:"OwnConsumption",Duplicate:"Duplicate"};export{n as MeteringPointType};
//# sourceMappingURL=types.js.map